module.exports = __webpack_public_path__ + "static/media/icon-delete-blue.d4f9545a.svg";